export default [
  {
    path: '/authenticate',
    name: 'authenticate',
    component: () => import('/@views/authenticate/index.vue'),
  },
  {
    path: '/logged-out',
    name: 'logged-out',
    component: () => import('/@views/logged-out/index.vue'),
  },
  {
    path: '/admin',
    name: 'admin',
    component: () => import('/@views/admin/index.vue'),
    children: [
      {
        path: 'artboards',
        name: 'artboards',
        component: () => import('/@views/admin/artboards/index.vue'),
        children: [
          {
            path: ':id',
            name: 'artboard',
            component: () => import('/@views/admin/artboards/artboard/index.vue'),
          },
        ],
      },
    ],
  },
  {
    path: '/',
    name: 'front',
    component: () => import('/@views/front/index.vue'),
    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import('/@views/front/login/index.vue'),
        props: true,
      },
      {
        path: 'screens',
        name: 'screens',
        component: () => import('/@views/front/screens/index.vue'),
        children: [
          {
            path: ':id?',
            name: 'screen',
            component: () => import('/@views/front/screens/screen/index.vue'),
          },
        ],
      },
    ],
  },
]
